/**
 * Произвольный банк произвольной страны.
 * Например, для использования в формах создания заявки на платеж или для учета счетов контрагентов.
 *
 * Реквизиты банков в разных странах могут называться по-разному, но смысл их везде одинаков,
 * поэтому здесь они поименованы максимально абстрактно.
 */
import Serializable from "@/core/misc/mixins/Serializable";
import Address from "@/domains/Address/Address";

class Bank extends Serializable {
	//#[Title_ru_RU('страна резидентства')]
	public countryCode: string;

	//#[Title_ru_RU('национальный идентификатор')]
	public id: string; // В РФ - БИК, в Узбекистане - МФО

	//#[Title_ru_RU('наименование')]
	public name: string;

	//#[Title_ru_RU('налоговый номер')]
	public tin: string | null; // TIN - Tax Identification Number, В РФ - ИНН

	//#[Title_ru_RU('адрес')]
	public address: Address;

	//Title_ru_RU('город')]
	public cityName?: string; // отдельно - наименование нас. пункта

	//#[Title_ru_RU('корреспондентский счет')]
	public account?: string;  // корр. счет в ЦБ своей страны

	static fromServer(data: any, bank = new Bank()): Bank {
		super.fromServer(data, bank);

		// bank.address = Address.fromServer(data.address) as Address;

		if (data && data.address) {
			bank.address = Address.fromServer(data.address) as Address;
		} else {
			bank.address = new Address();
		}

		return bank;
	}
}

export default Bank;
